<template>
  <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 py-8">
    <header class="mb-8 text-center sm:text-left">
      <h1 class="text-3xl sm:text-4xl font-bold tracking-tight text-slate-800 dark:text-slate-100">
        Controle <span class="bg-clip-text text-transparent bg-gradient-to-r from-brand-500 to-brand-400">de Investimentos</span>
      </h1>
      <p class="mt-2 text-sm text-slate-600 dark:text-slate-400">
        Gerencie seus investimentos e acompanhe o mercado em um só lugar.
      </p>
    </header>

    <div
      class="sticky top-0 z-10 -mx-2 mb-10 bg-slate-50/80 dark:bg-slate-900/80 backdrop-blur-xl rounded-2xl shadow-sm border border-slate-200 dark:border-slate-800 p-2 sm:p-3 flex justify-center sm:justify-start">
      <div class="flex overflow-x-auto gap-2 sm:gap-3 no-scrollbar">
        <button
          v-for="tab in tabs"
          :key="tab.value"
          @click="activeTab = tab.value"
          class="flex items-center whitespace-nowrap px-4 sm:px-5 py-2.5 text-sm font-medium rounded-xl transition-all duration-300"
          :class="activeTab === tab.value
            ? 'bg-gradient-to-r from-brand-600 to-brand-500 text-white shadow-md scale-[1.02]'
            : 'bg-transparent text-slate-600 dark:text-slate-300 hover:bg-slate-200/50 dark:hover:bg-slate-800/60 hover:text-slate-900 dark:hover:text-white'"
        >
          <span class="material-symbols-outlined text-base sm:text-lg mr-1">{{ tab.icon }}</span>
          {{ tab.label }}
        </button>
      </div>
    </div>

    <div class="relative">
      <transition name="fade" mode="out-in">
        <section v-if="activeTab === 'cripto'" key="cripto"><CryptoTracker embedded /></section>
        <section v-else-if="activeTab === 'radar'" key="radar"><ConsultaBolsa compact /></section>
        <section v-else key="investimentos"><InvestimentosPage compact /></section>
      </transition>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import InvestimentosPage from '@/components/investimentos/InvestimentosPage.vue'
import ConsultaBolsa from '@/components/saldos/ConsultaBolsa.vue'
import CryptoTracker from '@/components/conversor/CryptoTracker.vue'

const activeTab = ref('cripto')
const tabs = [
  { value: 'cripto', label: 'Criptomoedas', icon: 'currency_bitcoin' },
  { value: 'radar', label: 'B3', icon: 'timeline' },
  { value: 'investimentos', label: 'Investimentos', icon: 'savings' },
]
</script>

<style scoped>
.material-symbols-outlined {
  font-variation-settings: "FILL" 0, "wght" 500, "GRAD" 0, "opsz" 24;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(6px);
}
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
